import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  SharedFacade,
  ProjectsFacade,
  customEncode,
  customDecode,
  encrypt,
  decrypt,
  customEncrypt,
  customDecrypt,
} from '@piqet-angular/data';
import { ColDef } from 'ag-grid-community';
import { ActionButtonComponent } from 'libs/ui/src/lib/action-button/action-button.component';
import { GridIconComponent } from 'libs/ui/src/lib/grid-icon/grid-icon.component';
import { ProductManufactureDataGridService } from './product-manufacturing-data-grid.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { Subscription } from 'rxjs';
import { backToDashboardStr } from 'libs/shared/src/lib/constants';
import { AccessPermissionService, SwalService } from '@piqet-angular/shared';
import { ReportsService } from 'libs/data/src/lib/services/report/reports.service';
@Component({
  selector: 'piqet-angular-product-manufacture',
  templateUrl: './product-manufacture.component.html',
  styleUrls: ['./product-manufacture.component.scss'],
})
export class ProductManufactureComponent implements OnDestroy {
  columnDefs: ColDef[];
  activatedRouteProjectId: any;
  projectPackConversionDataPayload: any;
  activatedRoute: any;
  gridName: string = 'Product manufacture List';
  frameworkComponents = {
    actionRenderer: ActionButtonComponent,
    iconsOfTransport: GridIconComponent,
  };
  searchData: any = '';
  sortColumnState: any;
  productId: any;
  headerData = {
    name: 'Summary of product manufacturing process',
  };
  event: any;
  menuDataForRouting: any;
  nextRouteName: any;
  editPopUpOpenManufacture!: Subscription;
  backRouteType: any;
  activeProductProjectId: any;
  productConfigId: any;
  backBtnLabel: string = '';
  showEdit: boolean = false;

  constructor(
    private productManufactureDataGridService: ProductManufactureDataGridService,
    public sharedFacade: SharedFacade,
    public projectFacade: ProjectsFacade,
    public route: ActivatedRoute,
    private router: Router,
    private sharedService: SharedService,
    private accessService: AccessPermissionService,
    private reportsService: ReportsService,
    private swalService: SwalService
  ) {
    this.activatedRoute = this.route.snapshot.routeConfig?.path;
    this.columnDefs = this.productManufactureDataGridService.getProductManufactureDataColumn();

    this.route.queryParams.subscribe((values: any) => {
      this.projectPackConversionDataPayload = this.productManufactureDataGridService.getPayload(
        this.searchData
      );
      const url = location.href.split('/');
      this.productConfigId = Number(atob(decodeURIComponent(customDecode(url[6]))));
      const productId = customDecrypt(this.route.snapshot.queryParams['param']);
      this.productId = Number(productId.id);
      this.projectPackConversionDataPayload['draw'] = 1;
      this.projectPackConversionDataPayload['start'] = 0;
      this.projectFacade.getProductManufactureList(
        this.productId,
        this.projectPackConversionDataPayload
      );
    });

    this.sharedService.productProjectMenuArrData$.subscribe((res: any) => {
      if (res?.length) {
        this.menuDataForRouting = res.flatMap((product: any) =>
          product.submenu.map((scope: any) => ({
            ...scope,
            productId: product.productId,
            productName: product.name,
          }))
        );
      }
    });
  }
  ngOnDestroy(): void {
    this.editPopUpOpenManufacture.unsubscribe();
  }
  ngOnInit() {
    this.triggerScroll();
    this.showEdit = this.accessService.hasPermission('edit', '');
    this.editPopUpOpenManufacture =
      this.productManufactureDataGridService.editPopupOpenManufactureData$.subscribe(
        (data: any) => {
          this.addIngredientModal(data);
        }
      );
    this.findNextRoute();
  }

  triggerScroll(): void {
    this.sharedService.triggerScroll();
  }

  addIngredientModal(id: any) {
    this.projectFacade.openModalProductIngredient(
      this.productId,
      id || 0,
      'Add product manufacturing process to make 1kg/litre of product',
      this.activatedRoute
    );
  }

  findNextRoute() {
    const currentProductId = this.productId; // Fetch this from route or localStorage
    const activeIndex = this.menuDataForRouting.findIndex(
      (x: any) => x.description === this.activatedRoute && x.productId === currentProductId
    );

    // Find the next index and route
    const nextIndex = activeIndex + 1;
    if (
      nextIndex < this.menuDataForRouting.length &&
      this.menuDataForRouting[nextIndex].productId === currentProductId
    ) {
      this.nextRouteName = this.menuDataForRouting[nextIndex].description;
    } else {
      this.nextRouteName = 'chart-at-glance'; // No next route
      this.activeProductProjectId = localStorage.getItem('productConfigId');
    }

    if (!this.nextRouteName) this.backBtnLabel = backToDashboardStr;
    else this.backBtnLabel = 'Next';
  }

  async nextRoute() {
    this.findNextRoute();

    if (!this.nextRouteName) {
      this.router.navigate(['/dashboard']);
      return;
    }

    if (this.nextRouteName === 'chart-at-glance') {
      const activeProductProjectId: any = localStorage.getItem('productConfigId');
      const reportFormData: any = await this.reportsService.checkReportFromDataForProduct(
        activeProductProjectId
      );
      if (reportFormData && reportFormData.data) {
        const { item1, item2 } = reportFormData.data;

        if (item1 === false) {
          if (item2) {
            await this.swalService.confirmNew(
              'Report validation',
              item2,
              undefined,
              undefined,
              true
            );
          }
          return;
        } else {
          this.sharedService.accessProductSideBarData('charts');
          this.router.navigate([
            `projects/product-configuration/${this.productConfigId}/chart-at-glance`,
          ]);
          return;
        }
      }
    }
    const encryptedValue = customEncrypt(this.productId);
    this.router.navigate(
      [
        `projects/product-configuration/${customEncode(btoa(this.productConfigId))}/${
          this.nextRouteName
        }`,
      ],
      { queryParams: { param: encryptedValue } }
    );
  }

  findPrevRoute() {
    const currentProductId = this.productId; // Fetch this from route or localStorage
    const activeIndex = this.menuDataForRouting.findIndex(
      (x: any) => x.description === this.activatedRoute && x.productId === currentProductId
    );

    // Find the next index and route
    const nextIndex = activeIndex - 1;
    if (
      nextIndex < this.menuDataForRouting.length &&
      this.menuDataForRouting[nextIndex].productId === currentProductId
    ) {
      this.backRouteType = this.menuDataForRouting[nextIndex].description;
    } else {
      this.backRouteType =
        nextIndex < 0 ? 'configuration' : this.menuDataForRouting[nextIndex]?.description; // No next route
    }
  }

  backRoute() {
    this.findPrevRoute();
    const encryptedValue = customEncrypt(this.productId);
    this.router.navigate(
      [
        `projects/product-configuration/${customEncode(btoa(this.productConfigId))}/${
          this.backRouteType
        }`,
      ],
      { queryParams: { param: encryptedValue } }
    );
  }
}
